<template>
    <iframe :src="reel_id" class="instagram-media instagram-media-rendered" id="instagram-embed-0" allowtransparency="true" allowfullscreen="true" frameborder="0" height="943" scrolling="no"></iframe>
</template>
<script>
export default {
    props: ['reel_id'],
    methods: {
  }
}
</script>